import styled from 'styled-components';

import { NoResult } from 'ui/illustrations';
import { colors, fontSizes, fontWeights, spacing } from 'ui/theme';

const displayText = {
  headline: 'No matching results',
  caption: 'Try adjusting your filters or searching by different keywords.',
};

const Container = styled.div`
  width: 100%;
  position: relative;
  padding: ${spacing.x12} 0;
`;

const Message = styled.div`
  width: ${spacing.x32};
  margin: 0 auto;
  text-align: center;
`;

const Headline = styled.p`
  font-size: ${fontSizes.s20};
  margin: ${spacing.half} 0 0 0;
  color: ${colors.textPrimary};
  font-weight: ${fontWeights.bold};
`;

const Caption = styled.p`
  font-size: ${fontSizes.s16};
  margin: ${spacing.half} 0 0 0;
  color: ${colors.textSecondary};
`;

export const NoResultsMessage = () => (
  <Container data-test="workflows-index-no-results-message">
    <Message>
      <NoResult />
      <Headline>{displayText.headline}</Headline>
      <Caption>{displayText.caption}</Caption>
    </Message>
  </Container>
);
